import React, { useEffect } from "react";
import { Loader2 } from "lucide-react";

export const isPreparing = (d) => !!(d && d.preparing);

/** R7: a page whose snapshot is not ready yet — the worker is building it; poll every 10 s. */
export const Preparing = ({ section, onRetry }) => {
  useEffect(() => {
    const t = setInterval(() => onRetry && onRetry(), 10000);
    return () => clearInterval(t);
  }, [onRetry]);
  return (
    <div className="p-8 flex items-center gap-3 text-sm text-[#6B7280]" data-testid="page-preparing">
      <Loader2 className="w-4 h-4 animate-spin text-[#FF4802]" />
      <div><span className="font-medium text-[#333333]">Preparing {section}…</span> ready in about 1 min. This page refreshes itself.</div>
    </div>
  );
};
